export default __webpack_public_path__ + "static/media/MiterSawImg.bf0bbab3.jpg";